// @flow

import * as React from 'react';
import {Executable} from './_executable';

import KeyboardShortcuts from '../components/KeyboardShortcuts';

export class shortcuts extends Executable {
  commandName() {
    return 'shortcuts';
  }

  help() {
    this.setAllowInput(true);
    return 'shows keyboard shortcuts that can be used with the Stripe Shell';
  }

  run() {
    this.setAllowInput(true);
    return <KeyboardShortcuts />;
  }
}
